export default __webpack_public_path__ + "media/images/logo_transparent_black-138e1b8be4e0526ae8600ea6e48e04fa.svg";